namespace Nobox.Administration {

    @Serenity.Decorators.registerFormatter()
    export class TeamRoleFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            var item = ctx.item as UserRow;
            if (item.Owner == 1) {
                return `Owner`;
            } else {
                if (item.IsAdmin == 1) {
                    return `Manager`;
                } else {
                    return `Member`;
                }
            }
        }
    }
}